import axios from "axios";
axios.defaults.timeout = 600000
const axiosInstance = axios.create({
  // baseURL: `https://youcantseemeapi.matchcatch.com/`,
  baseURL: `https://api.matchcatch.com`, 
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("matchCatchToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("matchCatchToken");
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;